import { Template } from "../../models/Template";
import TemplateEvents from "../events/TemplateEvents";

// テンプレート追加・更新
export const UpdateTemplate = (
    templateFile: File,
    templateId: number,
    templateName: string,
    templateType: string,
    userId: number
) =>
    ({
        type: TemplateEvents.UpdateTemplateStarted,
        templateFile,
        templateId,
        templateName,
        templateType,
        userId,
    } as const);

export const UpdateTemplateComplete = (templateList: Template[]) =>
    ({
        type: TemplateEvents.UpdateTemplateComplete,
        templateList,
    } as const);

// テンプレート削除
export const DeleteTemplate = (templateId: number, userId: number, typeList: string[]) =>
    ({
        type: TemplateEvents.DeleteTemplateStarted,
        templateId,
        userId,
        typeList,
    } as const);

export const DeleteTemplateComplete = (templateList: Template[]) =>
    ({
        type: TemplateEvents.DeleteTemplateComplete,
        templateList,
    } as const);

export const DeleteTemplateFailed = (templateList: Template[], error: string) =>
    ({
        type: TemplateEvents.DeleteTemplateFailed,
        templateList,
        error,
    } as const);

export const ResetDeleteTemplateError = () =>
    ({
        type: TemplateEvents.ResetDeleteTemplateError,
    } as const);

// テンプレート名変更
export const RenameTemplate = (id: number, name: string, userId: number) =>
    ({
        type: TemplateEvents.RenameTemplateStarted,
        id,
        name,
        userId,
    } as const);

export const RenameTemplateComplete = (templateList: Template[]) =>
    ({
        type: TemplateEvents.RenameTemplateComplete,
        templateList,
    } as const);

// テンプレート一覧取得
export const GetTemplate = (typeList: string[]) =>
    ({
        type: TemplateEvents.GetTemplatesStarted,
        typeList,
    } as const);

export const GetTemplatesComplete = (templateList: Template[]) =>
    ({
        type: TemplateEvents.GetTemplatesComplete,
        templateList,
    } as const);
